import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import socket from '../../../../context/socket';
import _ from 'lodash';
import YearSelect from '../../StartedYear/year';
import { fetchClientData } from '../../../../redux/client/clientSlice';
import { useDispatch } from 'react-redux';
import api from '../../../../utils/api';

// Debounce function to delay API calls
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

const DreamHome = ({ roomId, card_id, planYourGoals }) => {
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [dreamHomeInputData, setDreamHomeInputData] = useState({
    amount: "",
    goalYear: "",
    downPayment: "",
    priceGrowth: "",
    startYear: new Date().getFullYear().toString(),
  });

  // Fetch the selected card and set the initial data

  useEffect(() => {
    if (!planYourGoals || !card_id) return;

    const card = planYourGoals.find((item) => item._id === card_id);
    setSelectedCard(card);

    if (card?.action_data?.[0]) {
      const {
        amount = "",
        goalYear = "",
        downPayment = "",
        priceGrowth = "",
        startYear = new Date().getFullYear().toString(),
      } = card.action_data[0];

      setDreamHomeInputData({
        amount,
        goalYear,
        startYear,
        downPayment,
        priceGrowth,
      });
    } else {
      // fallback if no action_data found
      setDreamHomeInputData((prev) => ({
        ...prev,
        startYear: new Date().getFullYear().toString(),
      }));
    }
  }, [planYourGoals, card_id]);


  // Function to save data via API
  const saveData = async (updatedData) => {
    // Check if all required fields are filled
    const allFieldsFilled =
      updatedData.amount !== "" &&
      updatedData.goalYear !== "" &&
      updatedData.downPayment !== "" &&
      updatedData.priceGrowth !== "" &&
      updatedData.startYear !== "";

    // Add the status based on field values
    // const dataWithStatus = {
    //   ...updatedData,
    //   status: allFieldsFilled ? 1 : 0, // Status is 1 if all fields are filled, otherwise 0
    // };

   const newStatus = allFieldsFilled ? 1 : 0;
      const prevCreatedAt = selectedCard?.created_at;

      const dataWithStatus = {
        ...updatedData,
        status: newStatus,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [dataWithStatus],
        status: newStatus,
      };

      // ✅ Add created_at ONLY ONCE at ROOT
      if (newStatus === 1 && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }
    try {
      const response = await api.post(`advisor/save_goal_data`,payload);
      dispatch(fetchClientData(roomId));

      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  // Debounced save function
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [selectedCard]
  );

  // Handle input changes
  const handleDreamHomeInputChange = (field, value) => {
    const updatedData = {
      ...dreamHomeInputData,
      [field]: value,
    };
    setDreamHomeInputData(updatedData);

    // Trigger the debounced save function
    debouncedSaveData(updatedData);
  };


  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard, dreamHomeInputData,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          dreamHomeInputData,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
      dreamHomeInputData,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
    dreamHomeInputData,

  ]);
  return (
    <>
      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            My dream home costs
            <span className="clrgreen fw-semibold"> ₹{" "}
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${dreamHomeInputData.amount?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                value={dreamHomeInputData.amount}
                // onChange={(e) =>
                //   handleDreamHomeInputChange("amount", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleDreamHomeInputChange("amount", value)
                  }
                }}
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="Cost"
              />
            </span>{" "}
            today, and I plan to buy it by{" "}
            <input
              type="number"
              style={{
                border: "none",
                borderBottom: "1px solid green",
                width: `${dreamHomeInputData.goalYear?.length + 3}ch`,
                paddingLeft: "1rem",
                minWidth: "8ch",
              }}
              value={dreamHomeInputData.goalYear}
              // onChange={(e) =>
              //   handleDreamHomeInputChange("goalYear", e.target.value)
              // }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  handleDreamHomeInputChange("goalYear", value)
                }
              }}
              className="clrgreen fw-bold ps-3 moinput"
              placeholder="Year"
            />.
          </p>
        </div>
      </div>

      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I want to save up for a{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${dreamHomeInputData.downPayment?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                value={dreamHomeInputData.downPayment}
                // onChange={(e) =>
                //   handleDreamHomeInputChange("downPayment", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleDreamHomeInputChange("downPayment", value)
                  }
                }}
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="0"
              />
            </span>{" "}
            % down payment on this property and finance the rest.
          </p>
        </div>
      </div>

      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I expect that its price will appreciate{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${dreamHomeInputData.priceGrowth?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                value={dreamHomeInputData.priceGrowth}
                // onChange={(e) =>
                //   handleDreamHomeInputChange("priceGrowth", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleDreamHomeInputChange("priceGrowth", value)
                  }
                }}
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="0"
              />
            </span>{" "}
            % from now till Year.
          </p>
        </div>
      </div>

      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            Start Year
            <span className="clrgreen fw-semibold">
              <select
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${dreamHomeInputData.startYear?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "8ch",
                }}
                value={dreamHomeInputData.startYear}
                onChange={(e) =>
                  handleDreamHomeInputChange("startYear", e.target.value)
                }
                className="clrgreen fw-bold ps-3 moinput"
              >
                <option value="">Select</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>
            </span>{" "}
          </p>
        </div>
      </div> */}

      <div className="row ps-3 align-items-center">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>

        <div className="col-md-9 col-10 d-flex align-items-center">
          <p className="fs-21 lh-sm me-2 pt-3">Start Year:</p>
          <div style={{ minWidth: "120px" }}>
            <YearSelect
              value={dreamHomeInputData.startYear}
              onChange={(val) => handleDreamHomeInputChange("startYear", val)}
              recentYear={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DreamHome;
